export default __webpack_public_path__ + "files/c7106e4ab743a4136ded0345a89b6875.woff2";